import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
class PieChart extends React.Component {
  render() {
    const chartOptions = {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: "pie"
      },
      series: [
        {
          name: "",
          colorByPoint: true,
          data: this.props.datos || []
        }
      ],
      title: {
        text: this.props.title || "Pie Chart Title"
      },
      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat:
          '<b>{point.y}</b> Denuncias  en <span style="color:{point.color}">{point.name}</span> <br> que representa el {point.percentage:.1f} % del Total'
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: true,
            format: "{point.name}: {point.percentage:.1f} %",
            connectorColor: "silver"
          },
          innerSize: "50%",
          showInLegend: true,
          startAngle: -90,
          endAngle: 90,
          center: ["50%", "75%"],
          size: "110%"
        }
      },
      colors: Highcharts.map(Highcharts.getOptions().colors, function (color) {
        return {
          radialGradient: {
            cx: 0.5,
            cy: 0.3,
            r: 0.7
          },
          stops: [
            [0, color],
            [
              1,
              Highcharts.Color(color)
                .brighten(-0.3)
                .get("rgb")
            ]
          ]
        };
      }),
      credits: {
        enabled: false
      },
      lang: {
        noData: "No hay datos para mostrar" //the text to be displayed
      },
      noData: {
        position: {
          x: 0,
          y: 0,
          align: "center",
          verticalAlign: "middle"
        }
      },
      exporting: {
        buttons: {
          contextButton: {
            menuItems: [{
              text: "Imprimir",
              textKey: 'printChart',
              onclick: function () {
                this.print();
              }
            }, {
              text: "Descargar como PNG",
              textKey: 'downloadPNG',
              onclick: function () {
                this.exportChart();
              }
            }, {
              text: "Descargar como JPEG",
              textKey: 'downloadJPEG',
              onclick: function () {
                this.exportChart({
                  type: 'image/jpeg'
                });
              }
            }, {
              text: "Descargar como PDF",
              textKey: 'downloadPDF',
              onclick: function () {
                this.exportChart({
                  type: 'application/pdf'
                });
              }
            }]
          }
        }
      }
    };
    return (
      <div>
        <HighchartsReact highcharts={Highcharts} options={chartOptions} />
      </div>
    );
  }
}

export default PieChart;
